import * as type from './types';

export function loginOtpSetStep(data) {
    return {
        type: type.SET_OTP_LOGIN_STEP_REQUESTED,
        data: data,
    }
}